<template>
  <div class="p-5 space-y-2 text-base">
    <div class="text-2xl py-4">
      นโยบายคุ้มครองข้อมูลส่วนบุคคล (Privacy Policy) แอปพลิเคชั่นนี้
    </div>
    <div>
      สำหรับพนักงานในเครือ บริษัท เนชั่นมัลติมีเดีย กรุ๊ป จำกัด มหาชน
      ซึ่งทางผู้จัดทำได้เคารพความเป็นส่วนตัวของข้อมูลส่วนบุคคลของผู้ใช้งาน
      และมีการปฏิบัติตามมาตรฐานความปลอดภัยและการรักษาความลับที่เข้มงวดอย่างที่สุด
      โดยเฉพาะในส่วนที่เกี่ยวเนื่องกับข้อมูลส่วนบุคคลทั้งหมดของผู้ใช้งานแอปพลิเคชั่นนี้
      ตามคำยินยอมของหนังสือให้ความยินยอมในการเปิดเผยข้อมูลส่วนบุคคล
      ที่แผนกทรัพยากรบุคคลได้จัดส่งให้ยินยอมให้ทางบริษัทเก็บข้อมูล
    </div>
    <ul class="space-y-2">
      <li>
        1. ข้อมูลส่วนบุคคลที่ทางบริษัทเก็บรวบรวม ใช้หรือเปิดเผยได้แก่
        <ul class="list-disc pl-8">
          <li>
            ชื่อ วันเดือนปีเกิด เพศ เลขบัตรประจำตัวประชาชน ภาพถ่ายบุคคล
            ใบอนุญาตขับรถหนังสือเดินทาง เชื้อชาติ ศาสนา หมู่เลือด
          </li>
          <li>
            ที่อยู่ หมายเลขโทรศัพท์มือถือและที่อยู่อีเมล
          </li>
          <li>
            โรงเรียนที่สำเร็จการศึกษา วิชาเอก การสำเร็จการศึกษาระยะเวลาเข้าเรียน
            ที่อยู่โรงเรียน การเป็นทหาร
            ประวัติการทำงานวุฒิบัตร/ประกาศนียบัตรผ่านการอบรม
          </li>
          <li>
            ข้อมูลสุขภาพ ความพิการ ข้อมูลชีวภาพ
          </li>
          <li>
            ประวัติอาชญากรรม
          </li>
          <li>
            ข้อมูลบัญชีธนาคาร ข้อมูลเงินค้ำประกัน
          </li>
          <li>
            ข้อมูลอื่นๆ ที่บริษัทเก็บเพื่อเป็นประโยชน์ในการจ้างงาน
            การจัดสวัสดิการ การพัฒนาบุคลากร และการดำเนินการตามที่กฎหมายกำหนด
          </li>
        </ul>
      </li>
      <li>
        2. วัตถุประสงค์เพื่อเก็บรวบรวม ใช้ ประมวลผล และ/หรือ
        เปิดเผยข้อมูลส่วนบุคคล
        <ul class="list-disc pl-8">
          <li>
            เพื่อใช้ในการดำเนินกระบวนการว่าจ้าง การจัดสวัสดิการ และ
            การพัฒนาบุคลากร ตลอดจนการทำสัญญาจ้าง
            การปฏิบัติตามสัญญาจ้างงานกับเจ้าของข้อมูล และ/หรือ
            สัญญาตามวัตถุประสงค์ด้านอื่น
          </li>
          <li>
            เพื่อเก็บข้อมูลชีวภาพ ตลอดจนใช้ข้อมูลในการตอบยืนยันสถานะพนักงาน
            ในการทำนิติกรรมทางการเงินหรือธุรกรรมอื่นๆของพนักงาน
          </li>
          <li>
            เพื่อดำเนินการจัดทำฐานข้อมูลพนักงาน และ บุคคลากร ทั้งบริษัทฯ และ
            บริษัทฯ ในเครือ
          </li>
          <li>
            เพื่อป้องกัน หรือ ระงับอันตรายต่อชีวิต ร่างกาย และ สุขภาพของบุคคล
          </li>
          <li>
            เพื่อเปิดช่องทางการสื่อสาร การประสานงานการทำงาน
          </li>
          <li>
            เพื่อปฏิบัติตามข้อบังคับ หรือข้อกำหนดอื่นๆ ตามกฎหมาย
          </li>
          <li>
            เพื่อดำเนินการภารกิจเพื่อผลประโยชน์สาธารณะ
          </li>
          <li>
            เพื่อดำเนินการจัดทำฐานข้อมูลพนักงาน
          </li>
          <li>
            เพื่อนำไปใช้ในการดำเนินธุรกิจของบริษัทและ/หรือบริษัทในเครือ
          </li>
          <li>
            เพื่อใช้ข้อมูลในการตอบยืนยันสถานะพนักงาน
          </li>
          <li>
            ในการทำนิติกรรมทางการเงินหรือธุรกรรมอื่นๆของพนักงาน
          </li>
        </ul>
      </li>
      <li>
        3. แหล่งที่มาของข้อมูลส่วนบุคคล
        แหล่งข้อมูลส่วนบุคคลทั้งหมดได้มาจากเอกสารสมัครงานและเอกสารอื่นๆ
        ที่ได้มาระหว่างที่พนักงานเป็นพนักงานของบริษัท
      </li>
      <li>
        4. ระยะเวลาในการเก็บรวบรวมข้อมูลส่วนบุคคล ดังนี้
        ข้อมูลส่วนบุคคลของผู้สมัครงานเก็บเป็นระระเวลา 2 ปีนับจากวันสมัครงาน
        ข้อมูลส่วนบุคคลของพนักงานเก็บเป็นระยะเวลา 5 ปี หลังพ้นสภาพพนักงาน
        ยกเว้นกรณีที่กฎหมายกำหนดให้เก็บข้อมูลดังกล่าวในระยะเวลาที่นานกว่านั้น
      </li>
      <li>
        5. การเปิดเผยข้อมูลส่วนบุคคล ข้อมูลส่วนบุคคลภายใต้การกำกับดูแลของบริษัทฯ
        และ บริษัทฯ ในเครือจะถูกเก็บรักษาไว้เป็นความลับตามหลักเกณฑ์ และ
        ข้อปฏิบัติของพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
        ทั้งนี้การเปิดเผยข้อมูลส่วนบุคคลมีขึ้นเพื่อวัตถุประสงค์ของการดำเนินการเกี่ยวกับบริหารทรัพยากรบุคคลการจ้างงาน
        การจัดสวัสดิการ การพัฒนาบุคลากร การยืนยันสถานะของพนักงานกับสถาบันการเงิน
        หรือหน่วยงานอื่นๆที่เกี่ยวข้องการดำเนินการทางธุรกิจ
        และการปฏิบัติตามข้อกำหนดของกฏหมาย
      </li>
      <li>
        6. การส่งหรือโอนข้อมูลส่วนบุคคลไปยังต่างประเทศ
        กรณีที่บริษัทถ่ายโอนข้อมูล ส่งต่อข้อมูล หรือ โอนข้อมูลไปยังต่างประเทศ
        บริษัทฯ จะจัดมาตราการสร้างความมั่นใจว่า องค์กรระหว่างประเทศ
        หน่วยงานที่รับโอนข้อมูล ส่งต่อข้อมูลในประเทศปลายทาง ได้มีการจัดมาตรการ
        วิธีการป้องกันข้อมูลส่วนบุคคลที่เพียงพอตามหลักเกณฑ์ที่กำหนดตามข้อกำหนดกฏหมายของพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
        หรือ กฏหมายอื่นที่เกี่ยวข้อง
      </li>
      <li>
        7. สิทธิการเพิกถอนความยินยอม เจ้าของข้อมูลส่วนบุคคล
        มีสิทธิเพิกถอนความยินยอมไม่ให้บริษัทเก็บรวบรวมข้อมูล การใช้ การประมวลผล
        หรือการเปิดเผยข้อมูลส่วนบุคคล โดยบริษัทจะจัดช่องทางให้เจ้าของข้อมูลฯ
        เข้าถึงและสามารถแจ้งความประสงค์เพิกถอนการยินยอมของข้อมูลของเจ้าของข้อมูลที่บริษัทฯดำเนินการเก็บรวบรวม
        การใช้ การประมวลผล และเปิดเผยข้อมูล
        โดยเจ้าของข้อมูลจะต้องให้เหตุผลถึงการเพิกถอนนี้
        การเพิกถอนการยินยอมของเจ้าของข้อมูลส่วนบุคคลจะไม่มีผลต่อการเก็บรวบรวม
        ใช้หรือเปิดเผยข้อมูลส่วนบุคคลที่เจ้าของข้อมูลส่วนบุคคลได้ให้การยินยอมไปก่อนหน้านี้
        โดยบริษัทฯ มีสิทธิขอยกเลิกการเพิกถอน
        หากเป็นไปตามวัตถุประสงค์เพื่อการปฏิบัติตามกฏหมาย และ การบริหารงานบุคคล
      </li>
      <li>
        8. สิทธิของเจ้าของข้อมูลส่วนบุคคล
        <ul class="list-disc pl-8">
          <li>
            ขอเข้าถึงและขอรับสำเนาข้อมูลส่วนบุคคลที่เกี่ยวกับตน
            หรือขอข้อมูลส่วนบุคคลคืนได้
          </li>
          <li>
            แจ้งแก้ไข เปลี่ยนแปลงข้อมูลส่วนบุคคลให้ถูกต้องเป็นปัจจุบัน สมบูรณ์
            และไม่ก่อให้เกิดความเข้าใจผิด
          </li>
          <li>
            เจ้าของข้อมูลส่วนบุคคลสามารถถอนความยินยอมในการเข้าถึงข้อมูลของผู้เก็บข้อมูล
            และสามารถขอให้ลบหรือทำลายข้อมูลตามความต้องการของเจ้าของข้อมูลเมื่อใดก็ได้
            ทั้งนี้ การถอนความยินยอมย่อมไม่ส่งผลกระทบต่อการเก็บรวบรวม ใช้
            หรือเปิดเผยข้อมูลส่วนบุคคลที่เจ้าของข้อมูลส่วนบุคคลได้ให้ความยินยอมไปแล้ว
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'privacy-policy',
  setup() {
    return {}
  }
})
</script>

<style scoped></style>
